import { createPinia } from 'pinia'
import { axiosInstance } from './axios'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { appConfig } from 'src/constants'
import LogRocket from 'logrocket'

function logRocketPiniaPlugin({ store }) {
  store.$subscribe((mutation, state) => {
    LogRocket.log(`[Pinia Mutation] ${mutation.storeId}`, {
      type: mutation.type,
      events: mutation.events,
      payload: mutation.payload,
      state,
    })
  })

  store.$onAction(({ name, store, args }) => {
    LogRocket.log(`[Pinia Action] ${store.$id}.${name}`, { args })
  })
}

export default ({ app, store, router }) => {
  const pinia = createPinia(),
    oidc = app.config.globalProperties.$oidc

  pinia.use(() => ({
    $axiosInstance: axiosInstance,
    $oidc: oidc,
    $router: router,
  }))

  pinia.use(
    createPersistedState({
      key: (id) => `ftx_commerce_store_${id}`,
    })
  )
  if (appConfig.LOG_ROCKET_APP_ID) pinia.use(logRocketPiniaPlugin)

  // Install Pinia plugin
  app.use(pinia)
}
